import LongLat from "../../types/base/LongLat";

export const convertPathToLatLngLiteral = (
  path: LongLat[]
): google.maps.LatLngLiteral[] => path.map(([lng, lat]) => ({ lat, lng }));
export const convertPolygonToBeOfLatLngLiterals = (polygon: LongLat[][]) =>
  polygon.map(convertPathToLatLngLiteral);
export const convertMultiPolygonToBeOfLatLngLiterals = (
  polygon: LongLat[][][]
) => polygon.map(convertPolygonToBeOfLatLngLiterals);
